<!-- begin:: Header Topbar -->
<div class="kt-header__topbar">


	<!--begin: Notifications -->
	<app-waiting-task  [bgImage]="basePath.pathRef+'assets/media/bg/notification_bg.jpg'" [pulse]="true" [skin]="'lilac'" [icon]="basePath.pathRef+'assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true"></app-waiting-task>
	<!--end: Notifications -->

		<!--begin: Notifications -->
	<app-processing-task  [bgImage]="basePath.pathRef+'assets/media/bg/notification_bg.jpg'" [pulse]="true" [skin]="'lilac'" [icon]="basePath.pathRef+'assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true"></app-processing-task>
		<!--end: Notifications -->

	<!--begin: Notifications -->
	<app-finished-task  [bgImage]="basePath.pathRef+'assets/media/bg/notification_bg.jpg'" [pulse]="true" [skin]="'lilac'" [icon]="basePath.pathRef+'assets/media/icons/svg/Code/Compiling.svg'" [useSVG]="true"></app-finished-task>
	<!--end: Notifications -->

	<!--begin: Language bar -->
	<!-- <kt-language-selector></kt-language-selector> -->
	<!--end: Language bar -->
	<!--begin: User bar -->
	<kt-user-profile ></kt-user-profile>
	<!--end: User bar -->
</div>
<!-- end:: Header Topbar -->
